// extracted by mini-css-extract-plugin
module.exports = {"iframe":"GlobalPaymentsForm_iframe__1GyV9"};